var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIntegrationRight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 124,
    viewBox: "0 0 124 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M87.8791 39.9912H81.3884C79.9768 39.9912 78.6344 40.6693 77.8041 41.8318L56.0487 72.0015L46.1951 58.3283C45.3648 57.1796 44.0362 56.4876 42.6107 56.4876H36.1201C35.2206 56.4876 34.6947 57.5117 35.2206 58.2452L52.4643 82.1595C52.8717 82.7281 53.4087 83.1914 54.0308 83.511C54.653 83.8306 55.3423 83.9973 56.0418 83.9973C56.7412 83.9973 57.4306 83.8306 58.0527 83.511C58.6749 83.1914 59.2119 82.7281 59.6192 82.1595L88.7648 41.7488C89.3045 41.0153 88.7786 39.9912 87.8791 39.9912Z",
    fill: "#258750"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62 0C27.7616 0 0 27.7616 0 62C0 96.2384 27.7616 124 62 124C96.2384 124 124 96.2384 124 62C124 27.7616 96.2384 0 62 0ZM62 113.482C33.5741 113.482 10.5179 90.4259 10.5179 62C10.5179 33.5741 33.5741 10.5179 62 10.5179C90.4259 10.5179 113.482 33.5741 113.482 62C113.482 90.4259 90.4259 113.482 62 113.482Z",
    fill: "#258750"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegrationRight);
export default __webpack_public_path__ + "static/media/integrationRight.cfc9be90f8609719bc535fec400cc288.svg";
export { ForwardRef as ReactComponent };